import clsx from "clsx";
import { SkeletonProps } from "../types";
import { Children, cloneElement } from "react";

/**
 * This is the most primitive element of a skeleton. Use it to compose more complex skeletons.
 * Children can be provided to this component to infer the size of the skeleton.
 * The children will be hidden from screen readers and styled to invisible.
 */

export function Skeleton({
  style,
  delayMs,
  className,
  children,
  ...props
}: SkeletonProps) {
  return (
    <div
      style={{ ...style, animationDelay: `${delayMs}ms` }}
      aria-label="Content loading..."
      aria-hidden="true" // Hide the contents from screen readers since this intended to be a visual effect
      className={clsx(
        "animate-gradient-diagonal bg-gradient-to-br from-gray-800 to-gray-900 bg-200%",
        className,
      )}
      {...props}
    >
      {Children.map(children, (child) => {
        if (!child) return;
        return cloneElement(child, {
          className: clsx(child.props.className, "!invisible"), // Hide all contents of the skeleton
        });
      })}
    </div>
  );
}
